import { Component, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatInputModule } from '@angular/material/input';
import { AmbientTemperature } from './ambient-temperature.model';

@Component({
  selector: 'app-ambient-temperature',
  imports: [FormField, MatInputModule],
  templateUrl: './ambient-temperature.component.html',
  styles: ``,
})
export class AmbientTemperatureComponent {

  readonly form = input.required<FieldTree<AmbientTemperature>>();
  readonly isBuried = input.required<boolean>();

  ngOnDestroy() {

    if (!this.form().airTemperature().valid())
      this.form().airTemperature().value.set(0);

    if (!this.form().groundTemperature().valid())
      this.form().groundTemperature().value.set(20);

  }

}
